import { typography, radius } from '@/shared/theme/tokens';
import { MONO } from './recommendedTheme';

// Tile sizing presets → fontSize TOKENS (legibility from weight + tile, not raw px).
const SIZES = {
  sm: { fontSize: typography.fontSize.lg,  pad: '3px 5px', minW: 16, gap: 3 },
  md: { fontSize: typography.fontSize['3xl'], pad: '5px 6px', minW: 22, gap: 4 },
  lg: { fontSize: typography.fontSize['5xl'], pad: '7px 8px', minW: 28, gap: 5 },
};

/**
 * Departures-board flip numeral, theme-aware (ported from the Board variant's
 * SplitFlap but coloured from `useThemeColors`, so it works in light AND dark).
 * Each character is a tile keyed by its char, so when a digit changes React
 * remounts ONLY that tile and the flip replays — the flip means "this changed".
 * Gated on `animate`; static under reduced-motion.
 */
export function FlipNumber({ value, color, c, size = 'md', animate = false }) {
  const s = SIZES[size] ?? SIZES.md;
  const chars = String(value).split('');
  return (
    <span style={{ display: 'inline-flex', gap: s.gap, perspective: 600, perspectiveOrigin: 'center top' }}>
      {chars.map((ch, i) => (
        // Position-keyed on purpose: only the changed slot remounts and flips.
        // eslint-disable-next-line react/no-array-index-key
        <Flap key={`${i}:${ch}`} ch={ch} s={s} color={color} c={c} animate={animate} />
      ))}
    </span>
  );
}

function Flap({ ch, s, color, c, animate }) {
  const isDigit = /[0-9]/.test(ch);
  return (
    <span style={{
      position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      minWidth: isDigit ? s.minW : undefined, padding: s.pad,
      fontFamily: MONO, fontSize: s.fontSize, fontWeight: typography.fontWeight.extrabold,
      lineHeight: 1, color, fontVariantNumeric: 'tabular-nums',
      background: c.bgSubtle, borderRadius: radius.sm, border: `1px solid ${c.border}`,
      transformStyle: 'preserve-3d', transformOrigin: 'center top',
      animation: animate ? 'rec-flip 0.4s cubic-bezier(0.34,0.9,0.32,1)' : 'none',
    }}>
      {/* center seam */}
      <span aria-hidden style={{
        position: 'absolute', left: 2, right: 2, top: '50%', height: 1, marginTop: -0.5,
        background: c.bgPage, opacity: 0.7,
      }} />
      <span style={{ position: 'relative' }}>{ch}</span>
    </span>
  );
}
